module.exports = __webpack_public_path__ + "img/NOaddress.6b05892f.png";